import { html, LitElement, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";

import {
  SlhCoreDropdownItem,
  SlhCoreDropdownItemCheckbox,
} from "@slhuicore/dropdown-item";
import { style } from "./assets/dropdown-item.generated-style";

/**
 * Allow users control option, or options, from a set of options, similar to a native <option> element
 *
 * @CustomElement slh-dropdown-item
 *
 * @cssprop --slh-default-font-family - Dropdown item font family.
 * @cssprop --slh-base-xs-font-size -Dropdown item font size.
 * @cssprop --slh-base-semi-bold-font-weight - Dropdown item font weight.
 * @cssprop --slh-base-xxs-line-height - Dropdown item font line height.
 * @cssprop --slh-color-neutral-shade-00 - Dropdown background.
 * @cssprop --slh-color-neutral-shade-10 - Dropdown hover and focus background.
 * @cssprop --slh-color-neutral-shade-40 - Dropdown disabled item font color.
 * @cssprop --slh-color-neutral-shade-60 - Dropdown item font color.
 * @cssprop --slh-color-neutral-shade-80 - Font color of highlighted/hovered dropdown item content.
 * @cssprop --slh-base-bold-font-weight - Font weight of highlighted dropdown item content.
 *
 * ** slots
 * @slot default - Plain text
 */
@customElement("slh-dropdown-item")
export default class SlhDropdownItem extends SlhCoreDropdownItem(LitElement) {
  static styles = style;

  /**
   * Render icon template
   */
  // eslint-disable-next-line class-methods-use-this
  private renderCheckbox(
    checkbox: SlhCoreDropdownItemCheckbox
  ): TemplateResult {
    return html`<slh-checkbox
      tabindex="-1"
      ?checked="${checkbox?.checked}"
      ?disabled="${checkbox?.disabled}"
    ></slh-checkbox>`;
  }
}
